<template>
  <div :id="id">
    <div class="cursor-pointer" @click="handleIconClick()">
      <aha-icon
        width="18"
        height="18"
        viewBox="0 0 14 14"
        name="kebab-menu"
      />
    </div>
    <aha-context-menu
      :ref="`context-menu-folder-${folder.folderId}`"
      :target="id"
      :x="targetX"
      :y="targetY"
    >
      <aha-context-menu-header>
        {{ folder.folderName }}
      </aha-context-menu-header>
      <aha-context-menu-item
        v-if="showRenameFolderItem"
        @click="handleRenameFolderItemClick()"
      >
        <aha-svg class="text-base-70" name="edit" />
        <span>{{ $i18nPresenter.t("Rename") }}</span>
      </aha-context-menu-item>
      <aha-context-menu-item
        @click="handleShowAddCollaborators()"
        v-if="showAddCollaborator"
      >
        <aha-svg
          width="20"
          height="20"
          class="text-base-70"
          name="invite-v2"
        ></aha-svg>
        <span>{{ $i18nPresenter.t("Add Collaborators") }}</span>
      </aha-context-menu-item>
      <aha-context-menu-item
        @click="handleDeleteFolderItemClick()"
        class="text-red-100"
        v-if="showDelete"
      >
        <aha-svg name="delete" />
        <span>{{ $i18nPresenter.t("Delete") }}</span>
      </aha-context-menu-item>
      <aha-context-menu-item
        @click="handleLeaveFolderItemClick()"
        class="text-red-100"
        v-if="showLeave"
      >
        <aha-svg name="logout" />
        <span>{{ $i18nPresenter.t("Leave") }}</span>
      </aha-context-menu-item>
    </aha-context-menu>

    <modal-delete-folder
      :folder="folder"
      v-if="isShowingDeleteFolderModal"
      @hide="handleHideDeleteFolderModal()"
    />
    <modal-delete-team-folder
      :folder="folder"
      v-if="isShowingDeleteTeamFolderModal"
      @hide="handleHideDeleteTeamFolderModal()"
    />
    <modal-rename-folder
      :folder="folder"
      v-if="isShowingRenameFolderModal"
      @hide="handleHideRenameFolderModal()"
    />
    <modal-update-team-folder
      v-if="isShowingEditTeamFolderModal"
      :folder="folder"
      @hide="handleHideEditFolderItemClick()"
    />
    <modal-add-collaborators
      v-if="isShowingAddCollaboratorsModal"
      :folder="folder"
      @hide="handleHideAddCollaboratorsModal()"
    />
  </div>
</template>
<script>
import { mapState } from 'vuex'
import * as Sentry from '@sentry/vue'
// utils
import utils from '@/util'

// constants
import constants from '@/constant'
import EventBus from '@/eventBus'

// api
import FolderApi from '@/api/folder'

// modals
import ModalDeleteFolder from '../../modals/DeleteFolder.vue'
import ModalDeleteTeamFolder from '../../modals/DeleteTeamFolder.vue'
import ModalRenameFolder from '../../modals/RenameFolder.vue'
import ModalUpdateTeamFolder from '../../modals/UpdateTeamFolder.vue'
import ModalAddCollaborators from '../../modals/AddCollaborators.vue'

const { eventCategories } = constants

export default {
  components: {
    ModalDeleteFolder,
    ModalDeleteTeamFolder,
    ModalRenameFolder,
    ModalUpdateTeamFolder,
    ModalAddCollaborators,
  },
  props: {
    folder: {
      type: Object,
      default: () => {},
    },
    id: {
      type: String,
      default() {
        return Math.random().toString().substring(7)
      },
    },
    rightClickEnabled: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isShowingEditTeamFolderModal: false,
      isShowingRenameFolderModal: false,
      isShowingDeleteFolderModal: false,
      isShowingDeleteTeamFolderModal: false,
      isShowingAddCollaboratorsModal: false,
      targetX: null,
      targetY: null,
      permissions: constants.permissions,
    }
  },
  computed: {
    ...mapState({
      currentFolderDepth: (state) => state.currentFolderDepth,
      currentUser: (state) => state.currentUser,
      currentFolder: (state) => state.currentFolder,
    }),
    showRenameFolderItem() {
      // if (this.folder.userId === this.currentUser.id ||
      //   (this.folder.permissions && this.folder.permissions.includes(this.permissions.EDIT_FOLDER_INFO))) return true
      // // return this.$route.name !== 'Team'
      // return false
      if (this.$route.name === 'Presentations') {
        return true
      }
      return this.checkPermissionFolderItem(this.permissions.EDIT_FOLDER_INFO)
    },
    showAddCollaborator() {
      // Ken debug hide addCollaborator from skoletube
      if (this.currentUser.identifyProvider === 'skoletube') {
        return false
      }
      return true
    },
    showDelete() {
      // if (this.$route.name === 'Presentations' || this.$route.name === 'FolderDetail') return true
      // if (this.folder.userId === this.currentUser.id ||
      //   (this.folder.permissions && this.folder.permissions.includes(this.permissions.DELETE_FOLDER))) return true
      // return false
      if (this.$route.name === 'Presentations') {
        return true
      }
      return this.checkPermissionFolderItem(this.permissions.DELETE_FOLDER)
    },
    showLeave() {
      if (this.currentUser.identifyProvider === 'skoletube') {
        return false
      }
      if (this.$route.name === 'SharedWithMe' && !this.folder.isSharedAccount) return true
      if (this.$route.name === 'ShareFolderDetail' && this.folder.hasInvitation) return true
      return false
    },
  },
  mounted() {
    if (this.rightClickEnabled) {
      EventBus.$on(`open-kebab-folder-${this.folder.folderId}`, ({ id, x, y }) => {
        if (id !== this.folder.folderId) {
          return
        }

        this.targetX = x
        this.targetY = y
        this.handleIconClick(true)
      })
    }
  },
  destroyed() {
    EventBus.$off(`open-kebab-folder-${this.folder.folderId}`)
  },
  methods: {
    handleDeleteFolderItemClick() {
      if (this.$route.name === 'Team') {
        this.isShowingDeleteTeamFolderModal = true
        utils.mixpanelTracking(eventCategories.PRESENTATION_LIST, 'Folder Kebab Menu > Delete Team Folder > Open modal', null, null, {
          isTeamFolder: this.$store.state.workingMode === constants.workspace.TEAM,
          role: this.currentUser.accountRole || null,
          teamId: this.$store.state.currentAccount.id || null,
          folderId: this.folder.folderId,
        })
      } else {
        this.isShowingDeleteFolderModal = true
        utils.mixpanelTracking(constants.eventCategories.PRESENTATION_LIST, 'Folder Kebab Menu > Delete Folder > Open modal', null, null, {
          parentFolderId: this.selectedFolderId,
          folderDepth: this.currentFolderDepth || 0,
        })
      }
    },
    async handleLeaveFolderItemClick() {
      try {
        await FolderApi.leaveFolderCollaborators(this.folder.folderId, {
          collaborators: [this.currentUser.email],
        })

        const index = this.folders.findIndex((folder) => {
          return folder.folderId === this.folder.folderId
        })
        this.folders.splice(index, 1)
        this.setFoldersAction(this.folders)
      } catch (e) {
        Sentry.captureException(e)
        if (e.body && e.body.message) {
          utils.showToastError(`Cannot leave folder ${this.folder.folderName}`)
        }
      } finally {
        EventBus.$emit('reload-presentations-and-folders')
      }
    },
    handleIconClick(exact) {
      if (!exact) {
        this.targetX = null
        this.targetY = null
      }

      this.isShowingRenameFolderModal = false
      this.$refs[`context-menu-folder-${this.folder.folderId}`].show()
      utils.mixpanelTracking(
        eventCategories.PRESENTATION_LIST,
        'Folder Kebab Menu > Open',
        null,
        null,
        {
          trigger: exact ? 'contextmenu' : 'click',
        },
      )
    },
    handleHideDeleteFolderModal() {
      this.isShowingDeleteFolderModal = false
      utils.mixpanelTracking(constants.eventCategories.PRESENTATION_LIST, 'Folder Kebab Menu > Delete Folder > Close modal', null, null, {
        parentFolderId: this.selectedFolderId,
        folderDepth: this.currentFolderDepth || 0,
      })
    },
    handleHideDeleteTeamFolderModal() {
      this.isShowingDeleteTeamFolderModal = false
    },
    handleHideRenameFolderModal() {
      this.isShowingRenameFolderModal = false
      utils.mixpanelTracking(eventCategories.PRESENTATION_LIST, 'Folder Kebab Menu > Rename Folder > Close modal')
    },
    handleHideEditFolderItemClick() {
      this.isShowingEditTeamFolderModal = false
      utils.mixpanelTracking(eventCategories.PRESENTATION_LIST, 'Folder Kebab Menu > Edit Folder > Close modal')
    },
    handleHideAddCollaboratorsModal() {
      this.isShowingAddCollaboratorsModal = false
      utils.mixpanelTracking(eventCategories.PRESENTATION_LIST, 'Folder Kebab Menu > Add Collaborators > Close modal')
    },
    handleRenameFolderItemClick() {
      this.isShowingRenameFolderModal = true
      utils.mixpanelTracking(constants.eventCategories.PRESENTATION_LIST, 'Folder Kebab Menu > Rename Folder > Open modal', null, null, {
        isTeamFolder: this.$store.state.workingMode === constants.workspace.TEAM,
        role: this.currentUser.accountRole || null,
        teamId: this.$store.state.currentAccount.id || null,
        folderId: this.folder.folderId || null,
      })
    },
    handleEditFolderItemClick() {
      this.isShowingEditTeamFolderModal = true
      utils.mixpanelTracking(constants.eventCategories.PRESENTATION_LIST, 'Folder Kebab Menu > Edit Folder > Open modal', null, null, {
        isTeamFolder: this.$store.state.workingMode === constants.workspace.TEAM,
        role: this.currentUser.accountRole || null,
        teamId: this.$store.state.currentAccount.id || null,
        folderId: this.folder.folderId,
      })
    },
    handleShowAddCollaborators() {
      this.isShowingAddCollaboratorsModal = true
    },
    checkPermissionFolderItem(permission) {
      // if (this.currentFolder) {
      return (this.currentFolder && this.currentFolder.ownerId === this.currentUser.id) ||
        (this.folder.permissions &&
          this.folder.permissions.includes(permission))
      // }
      // return false
    },
  },
}
</script>
